import React, { useState } from "react";
import { apiPut } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import { useForm } from "react-hook-form";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";
import OInputField from "components/reusable/OInputField";
import { preventMaxInput } from "utils/validations";
import formValidation from "../../../utils/formValidation";

const CategoryEdit = ({ allCategory, currentItem, handleEdit }) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      name: currentItem?.name,
    },
  });

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      data.name = data?.name?.trim();
      var path = apiPath.adminCategoryUpdate + "/" + currentItem._id;
      const result = await apiPut(path, data);
      if (result.data.success) {
        allCategory();
        handleEdit(false);
        notification.success(result?.data.message);
      } else {
        notification.error(result?.data.message);
      }
    } catch (error) {
      console.log("error in get all users list==>>>>", error);
      notification.error(error.message);
    }
    setIsLoading(false);
  };

  const renderFooter = () => (
    <div className="border-solid border-slate-200 rounded-b flex items-center justify-center p-6 border-t ">
      <button
        className="font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  text-black bg-[#E1E1E1] ease-linear transition-all duration-150"
        onClick={() => handleEdit(false)}
        type="button"
      >
        {t("O_BACK")}
      </button>

      {isLoading ? (
        <div className="spinner-container bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150">
          <div className="loading-spinner"></div>
        </div>
      ) : (
        <button
          onClick={handleSubmit(onSubmit)}
          type="submit"
          className="rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 ease-linear transition-all duration-150"
        >
          {t("O_SAVE")}
        </button>
      )}
    </div>
  );

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <div className="md:py-4 sm:px-2 sm:py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[550px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">
                  {t("CATEGORY_EDIT_CATEGORY")}
                </h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => handleEdit(false)}
                  title="Close"
                >
                  <span className=" text-[#B8BBBF]  text-4xl ">×</span>
                </button>
              </div>
              {/*body*/}
              <div className="relative p-6 flex-auto">
                <div className="sm:grid-cols-1 grid ">
                  <div className="sm:py-8 px-7 md:py-4 sm:px-2">
                    <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                      <OInputField
                        inputLabel={
                          <>
                            {t("CATEGORY_NAMES")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        placeholder=""
                        maxLength={50}
                        onInput={(e) => preventMaxInput(e, 50)}
                        wrapperClassName="w-full group relative z-0 "
                        type="text"
                        name="name"
                        id="name"
                        autoFocus={true}
                        register={register(
                          "name",
                          formValidation["categoryName"],
                        )}
                        errors={errors}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {renderFooter()}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black opacity-25 fixed inset-0 z-40 " />
    </>
  );
};

export default CategoryEdit;
